module.exports = __webpack_public_path__ + "img/trig.7374a4da.svg";